import React, { FC, useEffect } from 'react';
import { useActiveTheme } from '../../../theming/hooks/themeProvider';
import { CommunicationMessageEvents } from '../../interfaces/messageEvents';
import DocsLoadingError from '../docs-loading-error/DocsLoadingError';
import DocsLoadingShimmer from '../docs-loading-shimmer/DocsLoadingShimmer';

export const DocsIframe = React.forwardRef<any, {
  loadingParent?: boolean;
  isIframeLoading: boolean;
  error: any;
  docLink: string;
  iframeSourceURL: string;
  className?: string;
  onIframeLoadEvent?: () => any;
  onIframeLoadErrorEvent?: () => any;
  sendMessageToIframe: Function;
  LoadingComponent?: FC;
} & React.HTMLAttributes<HTMLDivElement>>(({
  loadingParent,
  isIframeLoading,
  error,
  docLink,
  iframeSourceURL,
  className,
  onIframeLoadEvent,
  onIframeLoadErrorEvent,
  sendMessageToIframe,
  LoadingComponent
}, ref) => {
  const loadingShimmerVisible = isIframeLoading || loadingParent;

  const iframeClasses = loadingShimmerVisible || error ? 'd-none' : '';

  const theme = useActiveTheme();

  useEffect(() => {
    if (!isIframeLoading) {
      sendMessageToIframe(CommunicationMessageEvents.DASH_COLOR_MODE_CHANGE, { mode: theme });
    }
  }, [theme, isIframeLoading, loadingParent]);

  return (
    <div className={className}>
      <iframe
        ref={ref}
        src={iframeSourceURL}
        className={iframeClasses}
        name='iframeWindow'
        height='100%'
        width='100%'
        frameBorder={0}
        // Docs pages declare no color-scheme; matching it keeps the iframe backdrop transparent in dark mode.
        style={{ colorScheme: 'light' }}
        onLoad={onIframeLoadEvent}
        onError={onIframeLoadErrorEvent}
      />

      {loadingShimmerVisible ? (
        <>
          {LoadingComponent ? <LoadingComponent /> : <DocsLoadingShimmer />}
        </>
      ) : null}

      {error && !loadingShimmerVisible ? (
        <DocsLoadingError
          title='Setup Guide is temporarily unavailable 😔'
          docLink={docLink}
        />
      ) : null}
    </div>
  );
});
